//TODO 1) imports
import React from 'react'

//TODO 2) Arrow function
const NotFound = () => {
  return <h1>Not found</h1>
}

//TODO 3) export NotFound.js and import to App.js
export default NotFound